import { memo } from 'react';
import { DialogTrigger } from 'react-aria-components';

import { Button, Flex, Heading, Text } from '@/components/core';
import { AddIcon } from '@/components/icons';
import { InviteMembersModal, MembersTable } from '@/components/ui';
import { ManagedRole } from '@/constants';

import { Page } from './Page';
import { Section } from './Section.tsx';
import { WorkspaceDetails } from './WorkspaceDetails.tsx';
import { WorkspaceHeader } from './WorkspaceHeader.tsx';

export type WorkspaceProps = object;

// eslint-disable-next-line no-empty-pattern
const IWorkspace = ({}: WorkspaceProps) => {
  return (
    <Page className="gap-md">
      <WorkspaceHeader>
        <Heading>Workspace</Heading>
        <Text>Manage your workspace.</Text>
      </WorkspaceHeader>

      <WorkspaceDetails showWorkspaceId className="border border-gray-200" />

      <Section title="Members" description="Manage your team and change roles and permissions.">
        <Flex col className="gap-sm">
          <MembersTable />
          <Flex className="w-full">
            <DialogTrigger>
              <Button variant="plain">
                <AddIcon />
                <Text>Add members</Text>
              </Button>
              <InviteMembersModal defaultRole={ManagedRole.Admin} />
            </DialogTrigger>
          </Flex>
        </Flex>
      </Section>
    </Page>
  );
};

export const Workspace = memo(IWorkspace) as typeof IWorkspace;
